import axios from "axios";

export default {
  state: {
    dataPartner: {
      partner_name: " ",
      partner_phone: [
        {
          phone: " ",
          hasViber: "hasViber"
        },
        {
          phone: "",
          hasViber: "noViber"
        }
      ],
      mail_partner: {
        mail: ""
      },
      addres_partner: {
        adres: " "
      },
      tagline_partner: {
        tagline: "Виза и работа в Польше "
      },
      theme_partner: {
        cardVakans: "teeal darken-3 white--text",
        iconVakans: "teal darken-4 white--text",
        btnVakans: "teal darken-3  white--text",
        header: " darken-4 white-text",
        headerName: " white--text",
        headerBtn: " white--text",
        futerContact: "teal white--text",
        futerdown: "teal white--text",
        futerCopyrait: "teal darken-4 white--text"
      }
    },
    FAQPartner: []
  },
  mutations: {
    UPDATE_PARTNER_CONFIG(state, dataPartner) {
      state.dataPartner = dataPartner;
    },
    UPDATE_PARTNER_FAQ(state, FAQPartner) {
      state.FAQPartner = FAQPartner;
    }
  },
  actions: {
    GET_PARTNER_CONFIG_FROM_API({ commit }) {
      // return axios("configPartner.php", {
      //  return axios("../config/configPartner.php", {
      return axios("../config/conf-partner.json", {
        method: "GET"
      })
        .then(dataPartner => {
          commit("UPDATE_PARTNER_CONFIG", dataPartner.data);
          return dataPartner.data;
        })
        .catch(error => {
          console.log(error);
          return error;
        });
    },
    GET_PARTNER_FAQ({ commit }) {
      // return axios("configPartner.php", {
      //  return axios("../config/configPartner.php", {
      // return axios(
      //   "http://partners.site/partners.site/public/config/question.php",
      return axios("../config/question.php", {
        method: "GET"
      })
        .then(FAQPartner => {
          console.log(FAQPartner);
          commit("UPDATE_PARTNER_FAQ", FAQPartner.data);
          return FAQPartner.data;
        })
        .catch(error => {
          console.log(error);
          return error;
        });
    }
  },
  getters: {
    PARTNER_CONFIG(state) {
      return state.dataPartner;
      // partner_name: state.dataPartner.partner_name,
      // partner_phone: state.dataPartner.partner_phone
    },
    FAQ_PARTNER(state) {
      console.log(state.FAQPartner);
      return state.FAQPartner;
    }
  }
};
